import { Controller } from "@hotwired/stimulus"

// Positions the Track Time panel's day timeline: opening the dropdown drops
// you at the current time (past days anchor 8 AM to the top instead --
// DayTimetable#scroll_anchor_px), while updates that replace the panel
// in place keep where you were.
//
// Anchoring can't live in connect() alone. The panel is a lazy turbo frame,
// so it loads once and reopening the dropdown never reconnects; and a
// resize PATCH re-renders the whole frame, which would otherwise fling the
// view back to now mid-drag.
const scrollByDate = new Map()

export default class extends Controller {
  static values = { anchor: Number, center: Boolean, date: String, force: Boolean }

  connect() {
    this.onDropdownShown = this.onDropdownShown.bind(this)
    this.rememberScroll = this.rememberScroll.bind(this)
    document.addEventListener("shown.bs.dropdown", this.onDropdownShown)
    this.element.addEventListener("scroll", this.rememberScroll, { passive: true })

    // forceValue means the server picked this anchor deliberately -- time
    // was just backfilled on this day -- so it outranks where you were.
    const remembered = scrollByDate.get(this.dateValue)
    if (this.forceValue || remembered === undefined) this.anchor()
    else this.element.scrollTop = remembered
  }

  disconnect() {
    document.removeEventListener("shown.bs.dropdown", this.onDropdownShown)
    this.element.removeEventListener("scroll", this.rememberScroll)
  }

  // A fresh open should always land on now, whatever the last position was.
  onDropdownShown(event) {
    if (!event.target.closest("#time-tracking-topbar")) return

    scrollByDate.clear()
    this.anchor()
  }

  // Deferred a frame: inside a just-shown dropdown the element can still
  // measure 0 tall, which would break the centering offset.
  anchor() {
    requestAnimationFrame(() => {
      const offset = this.centerValue ? this.element.clientHeight / 2 : 0
      this.element.scrollTop = Math.max(0, this.anchorValue - offset)
      scrollByDate.set(this.dateValue, this.element.scrollTop)
    })
  }

  rememberScroll() {
    scrollByDate.set(this.dateValue, this.element.scrollTop)
  }
}
